import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { AngularMaterialModule } from './angular-material/angular-material.module';
//import { NgImageSliderModule } from 'ng-image-slider';
//import { SlickModule } from 'ngx-slick';
import { NgxSlickJsModule } from 'ngx-slickjs'

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing/app-routing.module';

// Used for browser refeesh to work . it creates # data
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MenuIconComponent } from './components/menu-icon/menu-icon.component';
import { HomeComponent } from './components/home/home.component';
//import { AlertsComponent } from './components/alerts/alerts.component';
import { LoginComponent } from './components/login/login.component';

import { AppData } from './constants/app-data';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { EduSysCreateComponent } from './components/edu-sys/edu-sys-create/edu-sys-create.component';
import { EduSysUpdateComponent } from './components/edu-sys/edu-sys-update/edu-sys-update.component';
import { ChangePassComponent } from './components/change-pass/change-pass.component';
import { TestDashboardComponent } from './components/dashboard/test-dashboard/test-dashboard.component';
import { LeftComponent } from './components/menu/left/left.component';
import { TopComponent } from './components/menu/top/top.component';
import { RightComponent } from './components/menu/right/right.component';
import { EduSysViewComponent } from './components/edu-sys/edu-sys-view/edu-sys-view.component';
import { IndividualViewComponent } from './components/indiv/individual-view/individual-view.component';
import { IndividualCreateComponent } from './components/indiv/individual-create/individual-create.component';
import { TestSeriesComponent } from './components/dashboard/test-series/test-series.component';
import { SignupComponent } from './components/signup/signup.component';
import { CompSubMappingComponent } from './components/test-series/comp-sub-mapping/comp-sub-mapping.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { VideoConfigComponent } from './components/video-player/video-config/video-config.component';
import { TestHistoryComponent } from './components/test-series/test-history/test-history.component';
import { AboutComponent } from './components/about/about.component';
import { TermsOfUsageComponent } from './components/terms-of-usage/terms-of-usage.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { WriteToUsComponent } from './components/write-to-us/write-to-us.component';
import { TestInstructionsComponent } from './components/test-series/test-instructions/test-instructions.component';
import { TestQuestionPrepareInitComponent } from './components/test-series/test-question-prepare-init/test-question-prepare-init.component';
import { TestHistoryDetailComponent } from './components/test-series/test-history-detail/test-history-detail.component';
import { CustomDialogsComponent } from './components/dialog/custom-dialogs/custom-dialogs.component';
import { ConfirmationDialogComponent } from './components/dialog/confirmation-dialog/confirmation-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
        
    HeaderComponent,
    FooterComponent,
    MenuIconComponent,
    HomeComponent,
  //  AlertsComponent,
    LoginComponent,
  DashboardComponent,
  EduSysCreateComponent,
  EduSysUpdateComponent,
  ChangePassComponent,
  TestDashboardComponent,
  LeftComponent,
  TopComponent,
  RightComponent,
  EduSysViewComponent,
  IndividualViewComponent,
  IndividualCreateComponent,
  TestSeriesComponent,
  SignupComponent,
  CompSubMappingComponent,
  VideoPlayerComponent,
  VideoConfigComponent,
  TestHistoryComponent,
  AboutComponent,
  TermsOfUsageComponent,
  PrivacyPolicyComponent,
  WriteToUsComponent,
  TestInstructionsComponent,
  TestQuestionPrepareInitComponent,
  TestHistoryDetailComponent 
  
  ,CustomDialogsComponent, ConfirmationDialogComponent
  ],
  imports: [
    BrowserModule,
    NgxPaginationModule,
    //NgImageSliderModule,
    //SlickModule.forRoot(),
    NgxSlickJsModule.forRoot({
      links: {
        jquery: "https://code.jquery.com/jquery-3.4.0.min.js",
        slickJs: "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js",
        slickCss: "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css",
        slickThemeCss: "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css"
      }
  }),
    
    BrowserAnimationsModule,
    AngularMaterialModule,
    AppRoutingModule
  ],
  entryComponents:[CustomDialogsComponent, ConfirmationDialogComponent],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy},
  	AppData, HeaderComponent, CustomDialogsComponent
  	],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
